import { Component, ViewChild, ElementRef, AfterViewInit, Renderer2, Input, ChangeDetectionStrategy } from '@angular/core';
import { JkBaseComponent } from 'jk-service';

@Component({
  selector: 'app-webcam',
  standalone: true,
  imports: [],
  templateUrl: './webcam.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './webcam.component.scss'
})
export class WebcamComponent extends JkBaseComponent implements AfterViewInit {
  override comType: string = 'webcam';
  @ViewChild('videoElement') videoElement!: ElementRef;
  @Input() x: number = 1280;
  @Input() y: number = 720;
  camClass: any;
  private video!: HTMLVideoElement;
  private canvas!: HTMLCanvasElement;
  constructor(private renderer: Renderer2) {
    super();
  }
  initElement() {
    this.video = document.createElement('video');
    this.canvas = document.createElement('canvas');

    navigator.mediaDevices.getUserMedia({ video: true })
      .then(stream => {
        this.video.srcObject = stream;
        this.video.play();
      })
      .catch(err => console.error('Error accessing camera: ', err));
      //this._mqttService.observe('take_picture').subscribe((message: IMqttMessage) => {
      //  this.takePicture();
      //});
  }
  override ngOnInit() {
    super.ngOnInit();
    this.initElement();

  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();
    this.startCamera(this.x,this.y);
  }
  resize(x: number, y: number) {
    this.renderer.setProperty(this.videoElement.nativeElement, 'width', x);
    this.renderer.setProperty(this.videoElement.nativeElement, 'height', y);
  }

  async startCamera(x:number,y:number) {
    try {
      this.resize(x, y);
      const constraints = { audio: true,video: { width: x, height: y } }; // { audio: true, video: true }
      // {        video: { width: 1280, height: 720 }      }
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      this.videoElement.nativeElement.srcObject = stream;
    } catch (err: any) {
      let msg = '打開相機錯誤.'+err.message;
      alert(msg);
      console.error(msg);
    }
  }
  takePicture() {
    const context = this.canvas.getContext('2d');
    if (!context) {
      return;
    }
    this.canvas.width = this.video.videoWidth;
    this.canvas.height = this.video.videoHeight;
    context.drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);

    const dataUrl = this.canvas.toDataURL('image/png');
    this.sendEmail(dataUrl);
  }

  sendEmail(imageData: string) {
    alert('sendEmail'+imageData);
    // 使用您的後端 API 發送電子郵件
    fetch('https://your-backend-api/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        to: 'jackie57lo@gmail.com',
        subject: 'Picture from Angular App',
        body: 'Here is the picture you requested.',
        attachment: imageData
      })
    }).then(response => {
      if (response.ok) {
        console.log('Email sent successfully');
      } else {
        console.error('Failed to send email');
      }
    }).catch(error => {
      console.error('Error sending email: ', error);
    });
  }

}
